module.exports = __webpack_public_path__ + "img/logo-white.847a59ff.svg";